
import {
  Vue, DB, storage, Cookie, getQuery, getGameId, isProduction,
  sortTypeMap, getPlatform, getApkChannel, getServerTime, setServerTime
} from "../common"
import shuffle from 'lodash.shuffle'

export default {
  data(){
    let channelWhitelist = null
    let channelWhitelistStr = getQuery('channel_whitelist');
    if(channelWhitelistStr){
      channelWhitelist = channelWhitelistStr.split(',');
      let curChannel = Cookie.get('channel');
      if(!!curChannel && !channelWhitelist.includes(curChannel)){
        Cookie.set('channel', channelWhitelist[0], { expires: 365 });
      }      
    }
    return {
      gameId: getGameId(),
      channels: [],
      channelMap: {},
      curChannel: '',
      curSort: '',
      searchStr: '',
      searchKeyword: '',
      streams: [],
      isProduction: isProduction(),
      loadingConfig: false,
      loading: false,
      streamsError: false,
      configError: false,
      channelWhitelist,
    }
  },
  watch: {
    curChannel(newVal, oldVal){
      if(oldVal) {
        this.fetchStreams()
        this.curSort = this.channelData.sortTypes[0]
        this.searchStr = ''
        this.searchKeyword = ''
        Cookie.set('channel', this.curChannel, { expires: 365 }) // expires days
      }
    }
  },
  computed: {
    sortTypeMap(){ return sortTypeMap },
    obStreams(){
      // if(this.curChannel === 'cc') return this.filterStream(this.streams.slice)
      const streams = this.filterStream(this.streams.slice())
      const st = getServerTime()
      return streams.sort((a, b) => {
        const aUpType = a.upType !== 0 && a.upEndTime > st ? a.upType : 0
        const bUpType = b.upType !== 0 && b.upEndTime > st ? b.upType : 0
        if(aUpType !== bUpType){
          return bUpType - aUpType
        }else if(aUpType === bUpType && aUpType === 1){
          return b.upStartTime - a.upStartTime // 后设置的排在前面
        }else if(aUpType === bUpType && aUpType === -1){
          return a.upStartTime - b.upStartTime // 后设置的排在前面
        }else {
          return b.obNumber - a.obNumber
        }
      })
    },
    rdStreams(){
      // if(this.curChannel === 'cc') return this.filterStream(this.streams.slice)
      const streams = this.filterStream(this.streams.slice())
      return shuffle(streams)
    },
    zhStreams(){
      // if(this.curChannel === 'cc') return this.filterStream(this.streams.slice)
      const streams = this.filterStream(this.streams.slice())
      const st = getServerTime()
      return streams.sort((a, b) => {
        const aUpType = a.upType !== 0 && a.upEndTime > st ? a.upType : 0
        const bUpType = b.upType !== 0 && b.upEndTime > st ? b.upType : 0
        if(aUpType !== bUpType){
          return bUpType - aUpType
        }else if(aUpType === bUpType && aUpType === 1){
          return b.upStartTime - a.upStartTime // 后设置的排在前面
        }else if(aUpType === bUpType && aUpType === -1){
          return a.upStartTime - b.upStartTime // 后设置的排在前面
        }else {
          return a.originalOrder - b.originalOrder
        }
      })
    },
    channelData(){
      return this.channelMap[this.curChannel] || {}
    },
    showChannel(){
      if(this.channelWhitelist){
        return this.channels.filter(c=>this.channelWhitelist.includes(c.name));
      }else{
        return this.channels;
      }
    }
  },
  methods: {
    jumpToStream(stream){
      if(getPlatform() === 'pc'){
        if(this.curChannel === 'cc'){
          window.open(`http://cc.163.com/${stream.streamId.replace('-', '/')}`)
        }else if(this.curChannel === 'panda'){
          window.open(`http://www.panda.tv/liveplay/${stream.streamId}`)
        }else if(this.curChannel === 'bilibili'){
          window.open(stream.streamUrl)
        }else{
          this.$router.push('/stream/'+this.curChannel+'/'+stream.streamId)
        }
      }else{
        if(this.curChannel === 'bilibili0'){
          location.href = stream.streamUrl
        }else {
          this.$router.push('/stream/' + this.curChannel + '/' + stream.streamId)
        }
      }
    },
    saveScrollTop(){
      storage.setGlobal(`scrollTop-${this.curChannel}`, this.$refs.streamList.scrollTop)
    },
    recoverScrollTop(){
      const scrollTop = storage.getGlobal(`scrollTop-${this.curChannel}`)
      if(this.$refs.streamList) {
        this.$refs.streamList.scrollTop = scrollTop || 0
      }
    },
    changeChannelIndex(diff){
      const curIndex = this.channels.findIndex(c => c.name === this.curChannel)
      const nextIndex = curIndex + diff
      if(nextIndex >= 0 && nextIndex < this.channels.length) {
        this.curChannel = this.channels[nextIndex].name
      }
    },
    clearSearch(){
      this.searchKeyword = this.searchStr = ''
    },
    search(){
      this.searchKeyword = this.searchStr.trim().toLowerCase()
    },
    filterStream(ss){
      const searchKeyword = this.searchKeyword.toLowerCase()
      return searchKeyword ?
        ss.filter(s =>
          s.streamId.toString().includes(searchKeyword) ||
          s.streamDesc.toLowerCase().includes(searchKeyword) ||
          s.hostId.toString().toLowerCase().includes(searchKeyword)
        ) : ss
    },
    fetchGameConfig(){
      const channelIdFromUrl = this.$route.query.channel
      this.loadingConfig = true
      this.configError = false
      DB.request({
        url: DB.prefix + 'games/' + this.gameId,
        params: {
          apkChannel: getApkChannel(),
          platform: getPlatform(),
          channel: channelIdFromUrl,
        }
      }).then(data => {
        setServerTime(data.time)
        this.channels = data.data.game.channels
        const channelMap = {}
        this.channels.forEach(c => {
          channelMap[c.name] = c
        })
        this.channelMap = channelMap
        this.curChannel = data.data.curChannel;
        if(this.channelWhitelist && !this.channelWhitelist.includes(this.curChannel)){
          this.curChannel = this.channelWhitelist[0];
        }
        this.streams = data.data.streams
        this.curSort = this.channelData.sortTypes[0]
      }).catch(() => {
        this.configError = true
      }).then(() => {
        this.loadingConfig = false
        Vue.nextTick(() => {
          this.recoverScrollTop()
        })
      })
    },
    setGameConfig(config){
      this.channels = config.game.channels
      const channelMap = {}
      this.channels.forEach(c => {
        channelMap[c.name] = c
      })
      this.channelMap = channelMap
      this.curChannel = config.curChannel
      this.streams = config.streams
      this.curSort = this.channelData.sortTypes[0]
      this.configExtra = config.game.extra
    },
    fetchStreams(){
      const c = this.curChannel
      this.streams = []
      this.loading = true
      this.streamsError = false
      DB.request({
        url: DB.prefix + 'streams/' + this.gameId + '/' + c,
      }).then((data) => {
        if(this.curChannel === c){
          this.streams = data.data
        }
      }).catch(() => {
        this.streamsError = true
      }).then(() => {
        this.loading = false
      })
    },
    touchmoveChannelsHandler($event){
      const type = $event.type;
      const style = this.$refs.channels.style;
      if(type === 'touchstart'){
        this.startTouchPointX = $event.changedTouches[0].pageX;
        this.startTouchScrollLeft = this.$refs.channels.scrollLeft;
        this.maxScrollLeft = this.$refs.channels.scrollWidth - this.$refs.channels.clientWidth;
      } else if(type === 'touchmove'){
        const currentMoved = this.startTouchPointX - $event.changedTouches[0].pageX;
        const currentScrollLeft = this.startTouchScrollLeft + currentMoved;
        if(currentScrollLeft < 0){
          this.$refs.channels.scrollLeft = 0;
          style.removeProperty('right');
          style.left = Math.sqrt(Math.abs(currentScrollLeft)) + 'px';
        }else if(currentScrollLeft > this.maxScrollLeft){
          this.$refs.channels.scrollLeft = this.maxScrollLeft;
          style.removeProperty('left');
          style.right = Math.sqrt(Math.abs(currentScrollLeft - this.maxScrollLeft)) + 'px';
        }else{
          this.$refs.channels.scrollLeft = currentScrollLeft;
        }
      } else if(type === 'touchend'){
        if(style.left){
          style.left = '0px';
        }else if(style.right){
          style.right = '0px';
        }
        this.$refs.channels.classList.add('smooth-back');
        setTimeout(()=>{
          style.removeProperty('left');
          style.removeProperty('right');
          this.$refs.channels.classList.remove('smooth-back');
        }, 300);
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/home.js